/**
 * Shared payload readers for the recipient-side share-access realtime handlers
 * (correspondence_shares + task_shares). Both tables carry REPLICA IDENTITY FULL,
 * so `revoked_at` is present on old/new rows: `null` is the pre-revoke state and
 * a string is the revoked timestamp. `undefined` means the column was absent
 * (unknown) and every caller treats it as "skip, don't act".
 */

export function readShareRevokedAt(
  row: Record<string, unknown> | undefined,
): string | null | undefined {
  if (!row) {
    return undefined;
  }
  const value = row.revoked_at;
  if (value === null) {
    return null;
  }
  return typeof value === 'string' ? value : undefined;
}

export function readShareString(
  row: Record<string, unknown> | undefined,
  key: string,
): string | undefined {
  const value = row?.[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}
